var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousPageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-container-transform": "translate(0 4)",
    viewBox: "0 0 16 16",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0l-6 3-2 1 2 1 6 3-1.5-3h9.5v-2h-9.5l1.5-3z",
    transform: "translate(0 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousPageArrow);
export default __webpack_public_path__ + "static/media/previous-page-arrow.f5ab4d67cff53d385e3445f030b646cc.svg";
export { ForwardRef as ReactComponent };